import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { DocumentActionTypes } from 'store/actions/document.actions';
var initialState = {
    loading: [],
    err: undefined,
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case DocumentActionTypes.DELETE_DOCUMENT: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case DocumentActionTypes.DELETE_DOCUMENT_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, DocumentActionTypes.DELETE_DOCUMENT) });
        }
        case DocumentActionTypes.DELETE_DOCUMENT_FAILURE: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, DocumentActionTypes.DELETE_DOCUMENT) });
        }
        default: {
            return state;
        }
    }
}
var document = function (state) { return state.document; };
var ɵ0 = document;
var ɵ1 = function (state) { return state.loading; }, ɵ2 = function (state) { return state.err; };
export var Selectors = {
    getLoading: createSelector(document, ɵ1),
    getErrors: createSelector(document, ɵ2),
};
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2 };
